import { request } from '../utils/request';

export const userChatAPIs = {
  getChats: (query) => request(`/users/current/chats?${query}`),
  getChatDetail: (chatUuid, query) => request(`/users/current/chats/${chatUuid}?${query}`),
  createChat: (body) => request(`/users/current/chats`, { method: 'POST', body }),
  sendMessage: (chatUuid, body) => request(`/users/current/chats/${chatUuid}`, { method: 'POST', body }),
};
